export const prodConfigs = {
    serverUrl: process.env.REACT_APP_SERVER_URL,
}

export const devConfigs = {
    serverUrl: process.env.REACT_APP_DEV_SERVER_URL,
}

const probableHosts = ["http://localhost:3000", "http://localhost:3001", "http://localhost:3002"];

export const configs = probableHosts.includes(window.location.origin) ?
devConfigs : prodConfigs; 